

const Button = ({ title, onClick }) => {
  return (
    <button
      className="bg-orange text-xs p-2 text-white rounded-lg"
      onClick={onClick} // Pass the onClick handler to the button
    >
      {title}
    </button>
  );
};

export default Button;